import React, { useState, useEffect } from 'react';

import { setupMautic } from '../../utils/form';

function NewsletterForm() {
  const [email, setEmail] = useState('');

  useEffect(() => {
    setupMautic();
  }, []);

  function handleChange(e) {
    setEmail(e.target.value);
  }

  return (
    <div id="mauticform_wrapper_blognewsletter">
      <div
        className="newsletter__text newsletter__text--success"
        id="mauticform_blognewsletter_message"
      ></div>
      <p className="newsletter__text">
        Get notified about our new content for developers & business owners
      </p>
      <form
        autoComplete="false"
        method="post"
        action="https://mautic.accesto.pl/form/submit?formId=1"
        id="mauticform_blognewsletter"
        data-mautic-form="blognewsletter"
        encType="multipart/form-data"
        className="newsletter__form"
      >
        <div className="mauticform-error newsletter__error" id="mauticform_blognewsletter_error"></div>
        <div
          className="mauticform-page-wrapper mauticform-page-1"
          data-mautic-form-page="1"
        >
          <div
            id="mauticform_blognewsletter_email"
            data-validate="email"
            data-validation-type="email"
            className="newsletter__inputContainer"
          >
            <button
              type="submit"
              name="mauticform[submit]"
              id="mauticform_input_blognewsletter_submit"
              value=""
              className="mauticform-button newsletter__button"
            >
            </button>
            <input
              id="mauticform_input_blognewsletter_email"
              name="mauticform[email]"
              value={email}
              onChange={handleChange}
              className="mauticform-input newsletter__input"
              type="email"
              placeholder="Enter email"
            />
            <span className="mauticform-errormsg newsletter__error newsletter__emailError" style={{ display: 'none' }}>
              Email is required.
            </span>
          </div>

          <input
            id="mauticform_input_blognewsletter_persona"
            name="mauticform[persona]"
            value=""
            data-id="persona"
            className="mauticform-hidden"
            type="hidden"
          />
          <div
            id="mauticform_blognewsletter_email2"
            style={{ display: 'none' }}
            className="mauticform-row mauticform-email mauticform-field-4"
          >
            <label
              id="mauticform_label_blognewsletter_email2"
              htmlFor="mauticform_input_blognewsletter_email2"
              className="mauticform-label"
            >
              email2
            </label>
            <input
              id="mauticform_input_blognewsletter_email2"
              name="mauticform[email2]"
              value=""
              style={{ display: 'none' }}
              className="mauticform-input"
              type="email"
            />
            <span
              className="mauticform-errormsg newsletter__error"
              style={{ display: 'none' }}
            ></span>
          </div>
          <div
            id="mauticform_blognewsletter_consent"
            data-validate="consent"
            data-validation-type="checkboxgrp"
            className="mauticform-row mauticform-checkboxgrp mauticform-field-5 mauticform-required newsletter__consents"
          >
            <div className="mauticform-checkboxgrp-row">
              <label
                id="mauticform_checkboxgrp_label_consent_Yes0"
                htmlFor="mauticform_checkboxgrp_checkbox_consent_Yes0"
                className="mauticform-checkboxgrp-label newsletter__consentsLabel"
              >
                <input
                  className="mauticform-checkboxgrp-checkbox newsletter__consentsCheckbox"
                  name="mauticform[consent][]"
                  id="mauticform_checkboxgrp_checkbox_consent_Yes0"
                  type="checkbox"
                  value="Yes"
                />
                <span className="newsletter__consentsText">
                  I would like to subscribe to updates from Accesto
                </span>
              </label>
            </div>
            <span
              className="mauticform-errormsg newsletter__error newsletter__error--consents"
              style={{ display: 'none' }}
            >
              Unfortunately, we cannot subscribe you without your consent.
            </span>
          </div>
          <input
            id="mauticform_input_blognewsletter_source_page"
            name="mauticform[source_page]"
            value=""
            className="mauticform-hidden"
            type="hidden"
          />
          <div
            id="mauticform_blognewsletter_set_source_page"
            className="mauticform-row mauticform-freehtml mauticform-field-7"
          >
            <div
              id="mauticform_input_blognewsletter_set_source_page"
              name="mauticform[set_source_page]"
              value=""
              style={{ display: 'none' }}
              className="mauticform-freehtml"
            ></div>
          </div>
          <input
            id="mauticform_input_blognewsletter_persona2"
            name="mauticform[persona2]"
            value=""
            className="mauticform-hidden"
            type="hidden"
          />
          <div id="mauticform_blognewsletter_submit">

          </div>
        </div>

        <input
          type="hidden"
          name="mauticform[formId]"
          id="mauticform_blognewsletter_id"
          value="1"
        />
        <input
          type="hidden"
          name="mauticform[return]"
          id="mauticform_blognewsletter_return"
          value=""
        />
        <input
          type="hidden"
          name="mauticform[formName]"
          id="mauticform_blognewsletter_name"
          value="blognewsletter"
        />
      </form>
    </div>
  );
}

export default NewsletterForm;
